import { TutorialStep } from '../../../types/alice-bob';
import Phaser from 'phaser';
import { setTutorialStep } from '../../backend/store/tutorial';

export default class extends Phaser.Scene {
    constructor() {
        super('Preload');
    }

    init(): void {
        window.devtodev.customEvent("game_play_started", { "stage": 8 })

        let cx = this.cameras.main.centerX;
        let cy = this.cameras.main.centerY;

        let x = cx;
        let y = cy - 50;
        let logo = new Phaser.GameObjects.Sprite(this, x, y, 'preload_logo');
        this.add.existing(logo);

        x = cx;
        y = logo.getBounds().bottom - 10;
        let bar = new Phaser.GameObjects.Sprite(this, x, y, 'preload_bar');
        this.add.existing(bar);

        let width = bar.displayWidth;
        let height = bar.displayHeight;

        this.load.on('progress', (value: number) => {
            let scale = width * value;
            bar.setCrop(0, 0, scale, height);
        });
    }

    preload(): void {
        // fonts
        let fonts = ['league_spartan', 'league_spartan_medium', 'league_spartan_bold', 'lxgwwenkaitc_bold'];
        fonts.forEach((font) => this.load.bitmapFont(font, `assets/fonts/${font}_0.png`, `assets/fonts/${font}.fnt`));

        // audiosprites
        this.game.audio.load(this, ['sound', 'music']);

        // first chapter bg
        this.load.image('Hole', 'assets/images/bg/Hole.png');

        // atlases
        this.load.setPath(`assets/images`);
        this.load.multiatlas('atlas', `atlas.json`);

        // spine
        this.load.setPath('assets/spine/alice');
        this.load.spine('Alice', 'Alice.json', 'Alice.atlas', true);
        this.load.setPath('assets/spine/bob');
        this.load.spine('Bob', 'Bob.json', 'Bob.atlas', true);

        this.load.setPath('assets/spine/mobs');
        // this.load.spine('Dragon', 'Dagon.json', 'Dagon.atlas', true);
        // this.load.spine('Teapot', 'Teapot.json', 'Teapot.atlas', true);
        // this.load.spine('Crab', 'Crab.json', 'Crab.atlas', true);
        // this.load.spine('Fish', 'Fish.json', 'Fish.atlas', true);
        this.load.spine('Key_2', `Key_1/Key_1.json`, `Key_1/Key_1.atlas`);
        this.load.spine('Clocks', 'Clocks.json', 'Clocks.atlas', true);
        // this.load.spine('Seagul', 'Seagul.json', 'Seagul.atlas', true);
        this.load.spine('Golem', 'Golem.json', 'Golem.atlas', true);
        this.load.spine('Vines', 'Vines.json', 'Vines.atlas', true);
        this.load.spine('Debris', 'Debris.json', 'Debris.atlas', true);
        // this.load.spine('Walrus', 'Walrus.json', 'Walrus.atlas', true);
        this.load.spine('White Rabbit', 'White Rabbit.json', 'White Rabbit.atlas', true);
        // this.load.spine('Butterfly', 'Butterfly.json', 'Butterfly.atlas', true);

        // this.load.spine('Balls', 'Balls.json', 'Balls.atlas', true);
        // this.load.spine('Cheshire Cat', 'Cheshire Cat.json', 'Cheshire Cat.atlas', true);
        // this.load.spine('Mushroom', 'Mushroom.json', 'Mushroom.atlas', true);
        // this.load.spine('Snake', 'Snake.json', 'Snake.atlas', true);
        // this.load.spine('Skull', 'Skull.json', 'Skull.atlas', true);
        // this.load.spine('Wendigo', 'Wendigo.json', 'Wendigo.atlas', true);

        this.load.spine('Card_1', 'Card_1.json', 'Card_1.atlas', true);
        // this.load.spine('Card_2', 'Card_1.json', 'Card_1.atlas', true);
        this.load.spine('Card_3', 'Card_3.json', 'Card_3.atlas', true);
        // this.load.spine('Card_4', 'Card_3.json', 'Card_3.atlas', true);

        // this.load.spine('Chess', 'Chess.json', 'Chess.atlas', true);

        // this.load.spine('Chess2', 'Chess2.json', 'Chess2.atlas', true);
        // this.load.spine('Chess4', 'Chess4.json', 'Chess4.atlas', true);
        // this.load.spine('Deer', 'Deer.json', 'Deer.atlas', true);
        // this.load.spine('Hats', 'Hats.json', 'Hats.atlas', true);
        window.devtodev.customEvent("game_play_started", { "stage": 9 })
    }

    create(): void {
        window.devtodev.customEvent("game_play_started", { "stage": 10 })
        setTutorialStep(TutorialStep.LOADED_PRELOAD);
        this.scene.start('Game');
    }
}
